import { create } from "zustand";

const useRegionStore = create((set) => ({
  selectedRegion: null,
  selectedRegionList: null,
  receiveData: [],
  /**
   *
   * @param {number} selectRegion
   */
  setSelectedRegion: (selectRegion) => {
    set((state) => ({ ...state, selectedRegion: selectRegion }));
  },
  setSelectedRegionList: (selectRegionList) => {
    set((state) => ({ ...state, selectedRegionList: selectRegionList }));
  },
  setReceiveData: (receiveData) => {
    set({ receiveData });
  },
}));

export default useRegionStore;
